import React from 'react'

import Flex from '../../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../../components/dashboard/DashboardInput'

import { P } from '../../../../../../style/Typography.style'

const RemoteFitnessAssessmentReminder = ({
  referralEmail,
  onChange,
  fieldErrors,
}) => {
  return (
    <>
      <P marginBottom="0.5rem" weight="500">
        Remote Fitness Assessment Reminder Parameters
      </P>
      <Flex direction="column">
        <DashboardInput
          label="Referral Email"
          placeholder="Enter Referral Email"
          marginBottom="0.5rem"
          value={referralEmail}
          handleChange={(e) =>
            onChange('remote_fitness_referral_email', e.target.value)
          }
          errorMessage={fieldErrors.remote_fitness_referral_email}
        ></DashboardInput>
      </Flex>
    </>
  )
}

export default RemoteFitnessAssessmentReminder
